// Module
var code = `<table ng-table="\$ctrl.tableConfig" class="table">
    <tr>
      <th>No.</th>
      <th>Executed on</th>
      <th>Executed by</th>
      <th>Checks count</th>
      <th></th>
    </tr>
    <tr ng-repeat="item in \$data" ng-if="\$data">
      <td>{{ \$ctrl.getRowNo(\$index) }}</td>
      <td>{{ item.executedOn | prettyDateTime }}</td>
      <td>{{ item.executedByUsername }}</td>
      <td>{{ item.count }}</td>
      <td>
        <button
          class="btn btn-primary"
          ng-click="\$ctrl.seeDetails(item)">
          Details
        </button>
      </td>
    </tr>
    <tr ng-if="!\$data || !\$data.length" class="table__empty-message table__row--not-hoverable">
      <td colspan="4">Clearing history is blank</td>
    </tr>
</table>
`;
// Exports
var _module_exports = code;;
var path = 'src/app/components/inventory/batch-clearing-page/batch-clearing-history-list/batch-clearing-history-list.template.html';
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, _module_exports) }]);
module.exports = path;